import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EdOrdersSummaryView from "../../views/edOrdersSummary";
import { triggerShowHeader } from "../../redux/actions/action";
import config from "../../utils/config";
import {
  fetchUpdatedTimestamp,
  getAllPartners,
  getAllProductTypes,
  getEdOrdersSummaryData,
  resetEdOrdersSummary,
} from "../../redux/actions";

const EdOrdersSummary = () => {
  const dispatch = useDispatch();

  const tableRef = useRef();
  const [searchFields, setSearchFields] = useState({});
  const [timestamp, setTimestamp] = useState(null);

  const { filterValue, headerSelectedDateFrom, headerSelectedDateTo } =
    useSelector((state) => state.homeReducer);
  const { partners, productTypes, edOrdersSummary } = useSelector(
    (state) => state?.edOrdersSummaryReducer
  );

  const headers = [
    "SAF Creation Date",
    "ORN Number",
    "Product",
    "Plan Name",
    "Bandwidth",
    "Channels",
    "ARC",
    "OT Value",
    "HQ ID",
    "HQ Name",
    "Delivery State",
    "Delivery Status",
    "Delivery Date",
  ];

  const keyArray = [
    "safCreationDate",
    "orn",
    "productType",
    "planName",
    "bandwidth",
    "channels",
    "arc",
    "otValue",
    "hqId",
    "hqName",
    "deliveryState",
    "deliveryStatus",
    "deliveryDate",
  ];

  const colSpanArray = [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3];

  const onRunClick = () => {
    const edOrdersSummaryDTO = {
      headers: {
        url: "/getEdOrdersSummData",
        "Content-Type": "application/json",
      },
      params: {
        fromDate: headerSelectedDateFrom,
        toDate: headerSelectedDateTo,
        partnerId: searchFields?.partner?.partnerId ?? "",
        productType: searchFields?.productType,
        isRedisActive: "YES",
      },
    };
    if (tableRef.current) {
      tableRef.current.initializePage();
    }
    dispatch(getEdOrdersSummaryData(edOrdersSummaryDTO));
  };

  const getUpdatedTimestamp = useCallback(() => {
    const timestampDTO = {
      headers: {
        url: "/get-Updated-timestamp",
        "Content-Type": "application/json",
        type: "GET",
      },
      callback: (res) => setTimestamp(res?.content?.ED_ORDERS),
    };
    dispatch(fetchUpdatedTimestamp(timestampDTO));
  }, [dispatch]);

  const getAllPartnersList = useCallback(() => {
    const allPartnerDTO = {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        state: filterValue.selectedState
          ? filterValue.selectedState
          : searchFields?.state,
        userType: filterValue?.site,
        type: "ED Orders Summary",
      },
      callback: (res, params) => {
        setSearchFields((prev) => ({
          ...prev,
          partner: res?.content?.[0] ?? {},
        }));
      },
    };
    if (filterValue.selectedState || searchFields?.state)
      dispatch(getAllPartners(allPartnerDTO));
  }, [dispatch, filterValue?.site, searchFields?.state]);

  const getAllProductTypesList = useCallback(() => {
    const productTypesDTO = {
      headers: {
        url: "/getEdOrdersProductTypeList",
        "Content-Type": "application/json",
        type: "GET",
      },
    };
    dispatch(getAllProductTypes(productTypesDTO));
  }, [dispatch]);

  useEffect(() => {
    setSearchFields({
      productType: "ALL",
      region: filterValue.selectedRegion
        ? filterValue.selectedRegion
        : config?.region[0],
      state: filterValue.selectedState
        ? filterValue.selectedState
        : filterValue?.selectedRegion
        ? config.states?.[config.regionMaps[filterValue?.selectedRegion]]?.[0]
        : config?.states?.[
            config?.regionMaps?.[config?.region?.[0]?.toUpperCase()]
          ]?.[0],
    });
    dispatch(resetEdOrdersSummary());
  }, []);

  useEffect(() => {
    dispatch(triggerShowHeader(true));
  }, [dispatch]);

  useEffect(() => {
    getUpdatedTimestamp();
  }, [getUpdatedTimestamp]);

  useEffect(() => {
    if (
      ["nhq", "region head", "state head"].includes(
        filterValue.partnerName.toLowerCase()
      )
    )
      getAllPartnersList();
    else {
      setSearchFields({
        ...searchFields,
        partner: {
          parentId: null,
          parentName: null,
          partnerId: filterValue.orgId,
          partnerName: "END - AROHI TELECOMMUNICATIONS - 0662574743",
          partnerRoleType: null,
        },
        productType: "ALL",
      });
    }
  }, [getAllPartnersList]);

  useEffect(() => {
    getAllProductTypesList();
  }, [getAllProductTypesList]);

  return (
    <EdOrdersSummaryView
      searchFields={searchFields}
      setSearchFields={setSearchFields}
      timestamp={timestamp}
      partners={partners}
      productTypes={productTypes}
      onRunClick={onRunClick}
      headers={headers}
      keyArray={keyArray}
      colSpanArray={colSpanArray}
      edOrdersSummary={edOrdersSummary}
      partnerName={filterValue.partnerName}
      ref={tableRef}
    />
  );
};

export default EdOrdersSummary;
